import { CheckCircle2Icon, CircleAlertIcon, InfoIcon, TriangleAlertIcon } from 'lucide-react'
import { Toaster as Sonner, type ToasterProps } from 'sonner'

function Toaster({ ...props }: ToasterProps) {
  return (
    <Sonner
      position="bottom-center"
      visibleToasts={1}
      offset={16}
      toastOptions={{
        unstyled: true,
        className:
          'flex items-center gap-2 min-h-12 w-full px-4 py-3 rounded-xl text-sm font-medium text-foreground [&_[data-content]]:line-clamp-2',
        style: {
          background: 'hsl(var(--bg-raised))',
          border: '1px solid var(--glass-border)',
          boxShadow: '0 4px 24px rgba(0,0,0,0.4), 0 0 0 1px rgba(255,255,255,0.06)',
        },
      }}
      icons={{
        success: (
          <CheckCircle2Icon
            size={18}
            className="shrink-0"
            style={{ color: 'var(--status-success)' }}
          />
        ),
        error: (
          <CircleAlertIcon
            size={18}
            className="shrink-0"
            style={{ color: 'var(--status-error)' }}
          />
        ),
        warning: (
          <TriangleAlertIcon
            size={18}
            className="shrink-0"
            style={{ color: 'var(--status-warning)' }}
          />
        ),
        info: <InfoIcon size={18} className="shrink-0" style={{ color: 'var(--status-info)' }} />,
      }}
      {...props}
    />
  )
}

export { Toaster }
